export const STEPS = {
  SELECT_TIME_SLOTS: 0,
  SELECT_TIME_CUSTOMER_INFO: 1,
  SELECT_TIME_VIDEO_PLATFORM: 2,
  SUGGEST_SLOTS: 3,
  SUGGEST_SLOTS_CUSTOMER_INFO: 4,
};

export const CMS_PAGES = {
  PACKAGE_CONFIRMATION_URL: {
    en: '/en/confirmation-customer-booking',
    sv: '/sv/bokningsbekraftelse-kund/',
  },
  INVOICE_CONFIRMATION_URL: {
    en: '/en/invoice-booking-confirmation',
    sv: '/sv/bokningsbekraftelse-faktura/',
  },
  THANK_YOU_URL: {
    en: '/en/confirmation-customer-booking',
    sv: '/sv/bokningsbekraftelse-kund/',
  },
  CONTACT_US_URL: {
    en: '/en/contact-us/',
    sv: '/sv/kontakta-oss',
  },
};

export enum TIMESPAN {
  ALL_DAY = 'ALL_DAY',
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
}

export const TIMESPAN_HOURS = {
  [TIMESPAN.MORNING]: {
    startHours: 8,
    endHours: 12,
  },
  [TIMESPAN.AFTERNOON]: {
    startHours: 13,
    endHours: 17,
  },
  [TIMESPAN.EVENING]: {
    startHours: 17,
    endHours: 19,
  },
  [TIMESPAN.ALL_DAY]: {
    startHours: 8,
    endHours: 17,
  },
};
